import { FIRE_DEPARTMENT_IDS, LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Howard County Portal": {
    parameters: {
      linkUrls: [
        "https://www.howardcountymd.gov/fire-and-rescue-services/hazardous-materials-inspection-program",
        "https://www.notion.so/encamp/Howard-County-0c5703faaf5145ac975a3ab7e315d659",
      ],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
      includeFireDistricts: [
        {
          id: FIRE_DEPARTMENT_IDS.MD.HOWARD_COUNTY,
          name: "Howard Cnty Dept of Fire & Rescue",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "MD",
  },
  "Maryland Invoice": {
    parameters: {
      linkUrls: ["https://securesite.mde.state.md.us/TIER2MANAGER/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Organization",
    state: "MD",
  },
  "Maryland State Portal": {
    parameters: {
      linkUrls: ["https://securesite.mde.state.md.us/TIER2MANAGER/Account/Login.aspx"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "MD",
  },
  "Montgomery County Portal": {
    parameters: {
      linkUrls: ["https://hazmat.montgomerycountymd.gov/HAZMATPERMIT/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          report: true,
          invoice: true,
          receipt: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.MD.MONTGOMERY,
          name: "Montgomery County LEPC",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "MD",
  },
};
